import { createContext } from "react";
import { type MutateOptions } from "@tanstack/react-query";
import { type SigninInput, type SigninResponse } from "@/lib/backend/api";
import { type ExtractedError } from "@/lib/backend/utils/error";
import { type authClient } from "@/utils/auth";

interface SessionContextType {
  // session: UseQueryResult<SessionResponse, Error>;
  session: ReturnType<typeof authClient.useSession>;
  signin: (
    variables: SigninInput,
    options?: MutateOptions<SigninResponse, ExtractedError, SigninInput, unknown> | undefined,
  ) => Promise<SigninResponse>;

  signout: ReturnType<typeof authClient.signOut>;
}

export const SessionContext = createContext<SessionContextType | undefined>(undefined);
